import React from 'react';
import { Card } from "react-bootstrap";
import face_imre_varga from "../../assets/img/face_imre_varga.png";
import ShowMoreText from "react-show-more-text";
import proj_eigenv_stability from "../../assets/img/proj_eigenv_stability.png";

const Imre_Varga_eigenv_stability = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_eigenv_stability} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_imre_varga}
              /* this will be the text on the banner */
              alt="Multifractal Eigenvector Stability Against Structured Random Perturbations"
            />{" "}
            <p className="text7">Imre Varga</p>
            <br />
            <p className="text8">
              Associate Professor
            </p>
            <p className="text8">Department of Theoretical Physics, BME </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Eigenvectors of random matrices can exhibit complex scaling properties 
            characterized by multifractal dimensions rather than a single exponent. 
            How stable is this structure when the matrix entries are modified by a 
            small random perturbation? The goal of the work is to investigate how the 
            information dimension (D₁) and the correlation dimension (D₂) change 
            depending on the strength and structure of the perturbation.
            <br />
            <br />
            The starting point is the critical power-law banded random matrix model 
            (PBRM). The student analyzes the eigenvectors in a fixed basis, across 
            several matrix sizes and independent realizations. A central question is 
            distinguishing genuine scaling changes from finite-size effects. The 
            project is mathematical and numerical in nature.
            <br />
            <br />
            <b>Student Tasks:</b>
            <ol>
              <li>
                Learn the fundamentals of multifractal dimensions, Shannon and Rényi 
                entropies, and eigenvector perturbation theory.
              </li>
              <li>  
                Implement the PBRM model and verify the scaling of the unperturbed 
                eigenvectors in the middle of the spectrum.
              </li>
              <li>
                Compare two families of perturbations: fixed-bandwidth random symmetric 
                matrices and dense, GOE-type perturbations, using comparable normalization.
              </li>
              <li>
                Estimate the D₁ and D₂ dimensions from the logarithmic size-scaling of the 
                entropies; analyze the estimation uncertainty and the size-dependent effective 
                exponents.
              </li>
              <li>
                Interpret the results, compare them with the literature, and present them in a 
                reproducible manner.
              </li>
            </ol>
            <b>Prerequisites and Working Method:</b> Basics of linear algebra, probability theory,
              and numerical methods; basic programming experience. Computations can be carried out 
              in Python, primarily using NumPy, SciPy, and Matplotlib. The sizes and sample counts 
              studied are adapted to resources available on a laptop or in Google Colab.
            <br />
            <br />
            <b>Expected Outcome and Continuation:</b> The result of the semester is a documented 
            program or Jupyter notebook, a short written report, and an oral presentation. 
            The base task is limited to a fixed PBRM parameter and the D₁, D₂ dimensions; carefully 
            verified numerical conclusions constitute a solid standalone semester result. Within a 
            TDK or thesis project, one could investigate the effect of perturbations that decrease 
            with matrix size, stability thresholds and crossover size scales, the full D_q spectrum, 
            and the relationship between eigenvector rotation and changes in their multifractal structure.
            <br />
            <br />
            Related literature:{" "}
            <br />
            <ul>
                <li>
                <a href="https://journals.aps.org/pre/abstract/10.1103/PhysRevE.92.032914">R. Dubertrand et al. (2015).
                Multifractality of quantum wave functions in the presence of perturbations. 
                Physical Review E 92, 032914. arXiv:1506.05720</a>
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Imre_Varga_eigenv_stability;